// https://github.com/tc39/proposal-global
var $export = require('./_export');

$export($export.G, { global: require('./_global') });



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/es7.global.js
// module id = 297
// module chunks = 0 1 2 3 4